export default __webpack_public_path__ + "static/media/card.6a99ca00.svg";